// extracted by mini-css-extract-plugin
export default {"paymentContainer":"style_paymentContainer__t0+sS","cardsSection":"style_cardsSection__Sls0d","buttonSection":"style_buttonSection__3tIRG","button":"style_button__B+K-x"};